import userInfo from '@recoil/userInfo.atoms';
import { useSetRecoilState } from 'recoil';
import { useNavigate } from 'react-router-dom';
import { Button } from 'loplat-ui';
import { AuthUserApi } from '@api/index';
import * as S from '../styles';
import { useTranslation } from 'react-i18next';
import { gtagEvent } from '@function/gtag';

export interface Props {
  closeModal: () => void;
}

const LogOutModal = ({ closeModal }: Props) => {
  const { t } = useTranslation('modal/common');
  const setUser = useSetRecoilState(userInfo);
  const navigate = useNavigate();

  const onLogOutYes = () => {
    closeModal();
    gtagEvent({ eventName: '로그아웃' });
    setUser(null);
    AuthUserApi.logout();
    navigate('/login');
  };

  const onLogOutNo = () => {
    closeModal();
  };

  return (
    <>
      <S.ModalBody>
        <p>{t('logout')}</p>
      </S.ModalBody>

      <S.Footer>
        <Button color='ghost' onClick={onLogOutYes}>
          {t('yes')}
        </Button>
        <Button color='ghost' onClick={onLogOutNo}>
          {t('no')}
        </Button>
      </S.Footer>
    </>
  );
};

export default LogOutModal;
